<template>
  <div class="Component banner-image" v-if="bannerImage">
    <div class="wrapper-data">
      <h3 v-if="bannerTitleHtml" v-html="bannerTitleHtml"></h3>
      <div class="description" v-if="bannerDescriptionHtml" v-html="bannerDescriptionHtml"></div>
      <div class="additional-info" v-if="additionalDescription">
        <p>
          {{ additionalDescription }}
          <a v-if="additionalLink" :href="additionalLink" target="_blank" rel="noopener noreferrer">{{ linkText }}</a>
        </p>
      </div>
    </div>
    <img class="banner-img" :src="bannerImage" :alt="bannerAlt" />
  </div>
</template>

<script>
import { renderPrismicContent, getCleanPrismicImageUrl } from '../helpers/prismicHelpers';

export default {
  name: 'BannerImage',
  props: {
    sliceData: {
      type: Object,
      required: true
    },
    prismicLang: {
      type: String,
      required: true
    }
  },
  computed: {
    bannerTitleHtml() {
      const titleArray = this.sliceData?.primary?.highlight_title;
      if (!titleArray || !Array.isArray(titleArray) || titleArray.length === 0) {
        return '';
      }
      return renderPrismicContent(titleArray);
    },
    bannerDescriptionHtml() {
      const descArray = this.sliceData?.primary?.highlight_text;
      if (!descArray || !Array.isArray(descArray) || descArray.length === 0) {
        return '';
      }
      return renderPrismicContent(descArray);
    },
    bannerImage() {
      const url = this.sliceData?.primary?.highlight_image?.url || '';
      return getCleanPrismicImageUrl(url);
    },
    bannerAlt() {
      return this.sliceData?.primary?.highlight_image?.alt || 'Banner Image';
    },
    additionalDescription() {
      return this.sliceData?.primary?.additional_description || '';
    },
    additionalLink() {
      return this.sliceData?.primary?.additional_link || '';
    },
    linkText() {
      return this.sliceData?.primary?.link_text || 'Ver más';
    }
  }
};
</script>